import * as React from 'react';
import Svg, { Rect } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

function SvgComponent(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
            <Rect
                x={3}
                y={3}
                width={5.5}
                height={5.5}
                rx={1.5}
                stroke={props.color ?? ds.colorValue.icon.primary}
                strokeWidth={1.5}
            />
            <Rect
                x={11.5}
                y={3}
                width={5.5}
                height={5.5}
                rx={1.5}
                stroke={props.color ?? ds.colorValue.icon.primary}
                strokeWidth={1.5}
            />
            <Rect
                x={3}
                y={11.5}
                width={5.5}
                height={5.5}
                rx={1.5}
                stroke={props.color ?? ds.colorValue.icon.primary}
                strokeWidth={1.5}
            />
            <Rect
                x={11.5}
                y={11.5}
                width={5.5}
                height={5.5}
                rx={1.5}
                stroke={props.color ?? ds.colorValue.icon.primary}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
